export default __webpack_public_path__ + "static/media/icon-upload.ed8e435e.svg";